module.exports = __webpack_public_path__ + "img/8.1946aa6b.jpg";